module.exports = __webpack_public_path__ + "img/check.4cb49c8f.png";